module.exports = __webpack_public_path__ + "img/filtrate_pic.6ed288ff.svg";